// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yV5fE","top":"styles_top__1scT8"};